import React from 'react';
import { Route } from 'src/navigation/Route';
import { OfficialStoresScreen } from './screens/OfficialStoresScreen';

export const OFICIAL_STORES_ROUTES = {
  itself: '/lojas-oficiais',
};

export const OficialStoresNavigation = (): JSX.Element => (
  <React.Fragment>
    <Route
      exact
      path={OFICIAL_STORES_ROUTES.itself}
      component={OfficialStoresScreen}
      isPrivateRoute={true}
    />
  </React.Fragment>
);
